// AUTO GENERATED FILE - Changes WILL be lost.
// az - used as 'az' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Mərc kuponu",
  "product.last60-row-single": "NBA Son 60 Tək Matç",
  "product.sb-english-single": "İngilis Soccerbet Tək Maç",
  "product.sb-italian-single": "Italian Soccerbet Tək Maçı",
  "product.sb-greek-single": "Yunan Soccerbet Tək Maçı",
  "product.sb-english-league": "İngiltərə Futbol Liqası",
  "product.sb-italian-league": "İtaliya Futbol Liqası",
  "product.sb-greek-league": "Yunanıstan Futbol Liqası",
  "last60.fixture.pending": "{visitor} {'@'} {home}",
  "last60.fixture.result": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture.pending": "{home} VS. {away}",
  "sb.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "Mərc edin",
  "betslip.clear": "Hamısını sil, hamısını təmizlə",
  "betslip.clearResult": "SİL",
  "betslip.noSelections": "Mərc etməyə başlamaq üçün seçimlər əlavə edin",
  "betslip.notLoggedIn": "Bahis oynamağa başlamaq üçün daxil olun",
  "betslip.refresh": "Yeniləmək",
  "betslip.totalStake": "Ümumi mərc",
  "betslip.noHistoryData": "Heç bir mərc məlumatı yoxdur",
  "betslip.openBets": "Açıq mərclər",
  "betslip.betHistory": "Mərc Tarixi",
  "betslip.betHistoryWon": "Qazandı",
  "betslip.betHistoryLost": "itirilmiş",
  "loading.loading": "Yüklənir",
  "loading.account": "Hesab yüklənir",
  "loading.league": "Liqa yüklənir",
  "loading.gameweeks": "Oyun həftələri yüklənir",
  "loading.markets": "Marketlər yüklənir",
  "loading.bethistory": "Mərc tarixçəsi yüklənir",
  "login.loginRequired": "Giriş Tələb olunur",
  "login.loginToBet": "Bahis oynamağa başlamaq üçün daxil olun",
  "navigation.back": "Geri",
  "navigation.close": "Yaxın",
  "video.liveStreamAvailable": "Canlı yayım mövcuddur",
  "video.logInToWatch": "Baxmaq üçün daxil olun",
  "error.error": "Xəta",
  "error.404": "səhifə tapılmadı",
  "error.gameLaunchFailed": "Oyunu başlatmaq mümkün deyil",
  "error.unknownErrorCode": "Naməlum xəta: {code}",
  "error.minUnitStakeLimitExceeded": "Minimum mərc məbləği {limit}",
  "error.maxUnitStakeLimitExceeded": "Max mərc {limit}",
  "error.minTotalStakeLimitExceeded": "Minimum ümumi mərc məbləği {limit}",
  "error.maxTotalStakeLimitExceeded": "Maksimum ümumi mərc məbləği {limit}",
  "error.stakeInvalidMultiple": "Bahis şu değerlerin katı olmalıdır {multiple}",
  "error.notPlaced": "Yerləşdirilməyib",
  "error.wagerDisallowed": "Mərc etməyə icazə verilmir",
  "error.errorEventIsOff": "Oyun başladı",
  "wagerType.Singles": "Təkli",
  "wagerType.Doubles": "Sistem 2",
  "wagerType.Trebles": "Sistem 3",
  "wagerType.Accumulator": "Multi Mərc",
  "wagerType.Perm 4-Folds": "Sistem 4",
  "wagerType.Perm 5-Folds": "Sistem 5",
  "wagerType.Perm 6-Folds": "Sistem 6",
  "wagerType.Perm 7-Folds": "Sistem 7",
  "wagerType.Perm 8-Folds": "Sistem 8",
  "wagerType.Perm 9-Folds": "Sistem 9",
  "error.excess_bets": "Mərc kuponunda eyni vaxtda maksimum mərc {limit}; lütfən bir mərci silin",
  "product.sb-turkish-league": "Türkiyə Futbol Liqası",
  "error.minBetslipLimitExceeded": "Minimum mərc miqdarı təşkil edir {limit}",
  "error.maxBetslipLimitExceeded": "Maximum share məbləği təşkil  edir {limit}",
  "error.exceededMaxPayout": "Max uduş {limit}; zəhmət olmasa məbləğinizi azaldın.",
  "betslip.potentialReturns": "Potensial Uduşlar",
  "betslip.taxDisclaimer": "Bütün xalis uduşlarınız mərc hesablaşma zamanı vergiyə cəlb olunur. Vergi məbləği mərc üzrə potensial uduşlardan asılı olaraq hesablanacaq.",
  "error.maintenanceEnabled": "Server hazırda təmirdən keçir",
  "error.internalError": "Daxili səhv",
  "error.invalidSession": "Sessiya etibarsızdır",
  "error.accountDisabled": "Hesab deaktiv edilib",
  "error.invalidPlayerID": "Yanlış oyunçu ID",
  "error.insufficientBalance": "Qeyri-kafi balans",
  "error.configError": "Konfiqurasiya xətası",
  "error.betPlaceFailed": "Mərc etmək alınmadı",
  "error.invalidProductID": "Yanlış məhsul ID-si",
  "error.playerReachedGamingLimits": "Oyunçu məsul oyun limitlərinə çatdı",
  "error.gameCycleDoesNotExist": "Oyun dövrü mövcud deyil",
  "error.betAmountLimitExceeded": "Təsdiqlənməmiş oyunçular üçün potensial qazanma limitini aşdı",
  "betslip.netStake": "Xalis Stake",
  "betslip.tax": "vergi",
  "error.badReturns": "Potensial gəlirlər ümumi paydan aşağıdır",
  "betslip.taxDisclaimerPoland": "2.280 PLN-dən yuxarı məbləğlər üçün uduşlar 10% azalacaq.",
  "error.incompatibleVersion": "Dəstəklənməyən proqram versiyası. Zəhmət olmasa təkmilləşdirin.",
  "product.iihf-row-single": "IIHF Dünya Çempionatı",
  "iihf.fixture.pending": "{home} VS. {away}",
  "iihf.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "ui.returnToPlayer": "Oyunçuya Qayıdın",
  "abbr.ui.returnToPlayer": "RTP",
  "ui.averageReturnToPlayer": "Bu oyun üçün orta RTP {limit} təşkil edir",
  "error.betslipContainsInvalidOptions": "Betslip qırmızı ilə yanlış seçimləri ehtiva edir",
  "product.sb-scottish-single": "Scottish Soccerbet Tək Matç",
  "product.sb-spanish-single": "İspan Futbolu Tək Maçı",
  "product.sb-spanish-league": "İspaniya Futbol Liqası",
  "sb-english.team.ARS": "Arsenal",
  "sb-english.team.AST": "Aston V.",
  "sb-english.team.BHA": "Brayton",
  "sb-english.team.BOU": "Bornmut",
  "sb-english.team.BUR": "Börnli",
  "sb-english.team.CHE": "Çelsi",
  "sb-english.team.CRY": "K. Pelas",
  "sb-english.team.EVE": "Everton",
  "sb-english.team.LEI": "Lester",
  "sb-english.team.LIV": "Liverpul",
  "sb-english.team.MNC": "Mançester S.",
  "sb-english.team.MNU": "Mançester Y.",
  "sb-english.team.NEW": "Nyukasl",
  "sb-english.team.SOU": "Sauthempton",
  "sb-english.team.TOT": "Tottenhem",
  "sb-english.team.WAT": "Vatford",
  "sb-english.team.WHU": "Vest Hem",
  "sb-english.team.WOL": "Vulverhempton",
  "sb-english.team.NOR": "Norviç",
  "sb-english.team.SHU": "Şeffild Y.",
  "sb-english.team.LEE": "Lids",
  "sb-english.team.FUL": "Fulhem",
  "sb-english.team.WBA": "Vest Bromviç",
  "sb-greek.team.AEK": "AEK AFINA",
  "sb-greek.team.APS": "APOLLON SMİRNİS",
  "sb-greek.team.ARI": "ARIS SALONIKI",
  "sb-greek.team.AST": "ASTERAS TRIPOLI",
  "sb-greek.team.ATR": "ATROMITOS",
  "sb-greek.team.GIA": "PAS GIANNINA",
  "sb-greek.team.LEV": "LEVADIAKOS",
  "sb-greek.team.OFI": "OFI",
  "sb-greek.team.OLM": "OLİMPİAKOS",
  "sb-greek.team.PTK": "PANATINAIKOS",
  "sb-greek.team.PNS": "PANIONIOS",
  "sb-greek.team.PAO": "PAOK SALONIKA",
  "sb-greek.team.PLT": "PLATANIAS",
  "sb-greek.team.XAN": "KSANTİ",
  "sb-italian.team.MIL": "Milan",
  "sb-italian.team.ATA": "Atalanta",
  "sb-italian.team.BOL": "Bolonya",
  "sb-italian.team.BRE": "Breşiya",
  "sb-italian.team.CAG": "Kalyari",
  "sb-italian.team.CHI": "Kyevo",
  "sb-italian.team.FIO": "Fiorentina",
  "sb-italian.team.GEN": "Cenoa",
  "sb-italian.team.INT": "İnter",
  "sb-italian.team.JUV": "Juventus",
  "sb-italian.team.LAZ": "Latsio",
  "sb-italian.team.NAP": "Napoli",
  "sb-italian.team.ROM": "Roma",
  "sb-italian.team.SAM": "Sampdoriya",
  "sb-italian.team.UDI": "Udineze",
  "sb-italian.team.VER": "Verona",
  "nomorebets": "MƏRC QƏBULU BİTDİ",
  "playtime": "Oynama vaxtı",
  "gameId": "Oyun ID",
  "noGames": "Hazırda oyunlar mövcud deyil. Tezliklə yenidən yoxlayın.",
  "Home": "Ev",
  "Away": "Səfər",
  "Visitor": "Ziyarətçi",
  "rules": "Qaydalar",
  "soccerbet.gameWeek": "OYUN HƏFTƏSİ",
  "soccerbet.noGameWeeks": "Oyun həftələri mövcud deyil. Tezliklə yenidən yoxlayın.",
  "soccerbet.league": "LİQA TURNİR CƏDVƏLİ",
  "soccerbet.table.name": "ad",
  "soccerbet.table.won": "Q",
  "soccerbet.table.drawn": "H",
  "soccerbet.table.lost": "M",
  "soccerbet.table.points": "X",
  "abbr.event.Both Teams To Score": "QQ",
  "event.Both Teams To Score": "Hər iki komanda qol vuracaq",
  "event.Over / Under": "Üst/Alt",
  "event.Double Chance": "Cüt şans",
  "event.Match Result": "Oyun Nəticəsi",
  "event.Exact Goals": "Dəqiq qol sayı",
  "event.Correct Score": "DƏQİQ HESAB",
  "event.Match Result Both Score": "Oyun nəticəsi və hər iki komanda qol vuracaq",
  "event.Result Und/Over 1.5 Total Goals": "Oyun Nəticəsi və 1,5 Üst/Alt",
  "event.Result Und/Over 2.5 Total Goals": "Oyun Nəticəsi və 2,5 Üst/Alt",
  "event.Under Over 1.5 Total Goals": "1,5 Üst/Alt",
  "event.Under Over 2.5 Total Goals": "2,5 Üst/Alt",
  "event.Under Over 3.5 Total Goals": "3,5 Üst/Alt",
  "event.Under Over 4.5 Total Goals": "4,5 Üst/Alt",
  "event.Total Goals 1 To 2": "Dəqiq qol sayı 1 - 2",
  "event.Total Goals 1 To 3": "Dəqiq qol sayı 1 - 3",
  "event.Total Goals 1 To 4": "Dəqiq qol sayı 1 - 4",
  "event.Total Goals 2 To 3": "Dəqiq qol sayı 2-3",
  "event.Total Goals 2 To 4": "Dəqiq qol sayı 2-4",
  "event.Under Over 1.5 Home Goals": "ESK 1,5 Üst/Alt",
  "event.Under Over 1.5 Away Goals": "QK 1,5 Üst/Alt",
  "event.Home Team Exact Goals": "ESK dəqiq qol sayı",
  "event.Away Team Exact Goals": "QK dəqiq qol sayı",
  "selection.Yes": "B",
  "selection.No": "X",
  "selection.1+G": "1+Qol/Qol",
  "selection.1+Ng": "1+Yox/QOL",
  "selection.X+G": "X + Qol/Qol",
  "selection.X+Ng": "X+Yox/Qol",
  "selection.2+G": "2+Qol/Qol",
  "selection.2+Ng": "2+Yox/Qol",
  "selection.1+Yes": "1+Qol/Qol",
  "selection.1+No": "1+Yox/Qol",
  "selection.X+Yes": "X+Qol/Qol",
  "selection.X+No": "X+Yox/Qol",
  "selection.2+Yes": "2+Qol/Qol",
  "selection.2+No": "2+Yox/Qol",
  "selection.TID_ANY_GOAL_SCORED_YES": "Qol/Qol",
  "selection.TID_ANY_GOAL_SCORED_NO": "Yox/Qol",
  "selection.U": "A",
  "selection.O": "Ü",
  "selection.1+O": "1+Ü",
  "selection.X+O": "X+Ü",
  "selection.2+O": "2+Ü",
  "selection.1+U": "1+A",
  "selection.X+U": "X+A",
  "selection.2+U": "2+A",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1X",
  "selection.TID_DRAW_OR_AWAY_WIN": "X2",
  "selection.TID_HOME_OR_AWAY_WIN": "12",
  "selection.Over": "ÜST",
  "selection.Under": "ALT",
  "abbr.sb-english.team.ARS": "ARS",
  "abbr.sb-english.team.AST": "AST",
  "abbr.sb-english.team.BHA": "BRA",
  "abbr.sb-english.team.BOU": "BOR",
  "abbr.sb-english.team.BUR": "BÖR",
  "abbr.sb-english.team.CHE": "ÇEL",
  "abbr.sb-english.team.CRY": "KRİ",
  "abbr.sb-english.team.EVE": "EVE",
  "abbr.sb-english.team.LEI": "LES",
  "abbr.sb-english.team.LIV": "LIV",
  "abbr.sb-english.team.MNC": "MSİ",
  "abbr.sb-english.team.MNU": "MYU",
  "abbr.sb-english.team.NEW": "NYU",
  "abbr.sb-english.team.SOU": "SOU",
  "abbr.sb-english.team.TOT": "TOT",
  "abbr.sb-english.team.WAT": "VOT",
  "abbr.sb-english.team.WHU": "WHU",
  "abbr.sb-english.team.WOL": "VUL",
  "abbr.sb-english.team.NOR": "NOR",
  "abbr.sb-english.team.SHU": "ŞEF",
  "abbr.sb-english.team.LEE": "LİD",
  "abbr.sb-english.team.FUL": "FUL",
  "abbr.sb-english.team.WBA": "VES",
  "abbr.sb-italian.team.MIL": "MIL",
  "abbr.sb-italian.team.ATA": "ATA",
  "abbr.sb-italian.team.BOL": "BOL",
  "abbr.sb-italian.team.BRE": "BRE",
  "abbr.sb-italian.team.CAG": "KAL",
  "abbr.sb-italian.team.CHI": "KİY",
  "abbr.sb-italian.team.FIO": "FIO",
  "abbr.sb-italian.team.GEN": "CEN",
  "abbr.sb-italian.team.INT": "INT",
  "abbr.sb-italian.team.JUV": "YUV",
  "abbr.sb-italian.team.LAZ": "LAZ",
  "abbr.sb-italian.team.NAP": "NAP",
  "abbr.sb-italian.team.ROM": "ROM",
  "abbr.sb-italian.team.SAM": "SAM",
  "abbr.sb-italian.team.UDI": "UDI",
  "abbr.sb-italian.team.VER": "VER",
  "abbr.sb-greek.team.AEK": "AEK",
  "abbr.sb-greek.team.APS": "APO",
  "abbr.sb-greek.team.ARI": "ARI",
  "abbr.sb-greek.team.AST": "AST",
  "abbr.sb-greek.team.ATR": "ATR",
  "abbr.sb-greek.team.GIA": "GİA",
  "abbr.sb-greek.team.LEV": "LEV",
  "abbr.sb-greek.team.OFI": "OFI",
  "abbr.sb-greek.team.OLM": "OLİ",
  "abbr.sb-greek.team.PTK": "PAN",
  "abbr.sb-greek.team.PNS": "PNS",
  "abbr.sb-greek.team.PAO": "PAO",
  "abbr.sb-greek.team.PLT": "PLA",
  "abbr.sb-greek.team.XAN": "XAN",
  "sb-turkish.team.AKB": "AKHİSARSPOR",
  "sb-turkish.team.BES": "BEŞİKTAŞ",
  "sb-turkish.team.FEN": "FƏNƏRBAXÇA",
  "sb-turkish.team.GAL": "QALATASARAY",
  "sb-turkish.team.TRA": "TRABZONSPOR",
  "sb-turkish.team.ANT": "ANTALYASPOR",
  "sb-turkish.team.GEN": "GƏNCLƏRBİRLİYİ",
  "sb-turkish.team.KAS": "KASIMPAŞA",
  "sb-turkish.team.BUR": "BURSASPOR",
  "sb-turkish.team.KAY": "KAYSERİSPOR",
  "sb-turkish.team.SIV": "SİVASSPOR",
  "sb-turkish.team.IBA": "İSTANBUL BAŞAKŞƏHƏR",
  "sb-turkish.team.HAT": "HATAYSPOR",
  "sb-turkish.team.ADS": "ADANA DƏMİRSPOR",
  "sb-turkish.team.ALT": "ALTAY",
  "sb-turkish.team.GAZ": "QAZİANTEP",
  "sb-turkish.team.GOZ": "GÖZTƏPƏ",
  "sb-turkish.team.KON": "KONYASPOR",
  "sb-turkish.team.CRS": "ÇAYKUR RİZƏSPOR",
  "sb-turkish.team.ALS": "ALANYASPOR",
  "abbr.sb-turkish.team.AKB": "AKH",
  "abbr.sb-turkish.team.BES": "BJK",
  "abbr.sb-turkish.team.FEN": "FB",
  "abbr.sb-turkish.team.GAL": "QS",
  "abbr.sb-turkish.team.TRA": "TRA",
  "abbr.sb-turkish.team.ANT": "ANT",
  "abbr.sb-turkish.team.GEN": "GB",
  "abbr.sb-turkish.team.KAS": "KAS",
  "abbr.sb-turkish.team.BUR": "BUR",
  "abbr.sb-turkish.team.KAY": "KAY",
  "abbr.sb-turkish.team.SIV": "SİV",
  "abbr.sb-turkish.team.IBA": "İBŞ",
  "abbr.sb-turkish.team.HAT": "HAT",
  "abbr.sb-turkish.team.ADS": "ADS",
  "abbr.sb-turkish.team.ALT": "ALT",
  "abbr.sb-turkish.team.GAZ": "QZA",
  "abbr.sb-turkish.team.GOZ": "GÖZ",
  "abbr.sb-turkish.team.KON": "KON",
  "abbr.sb-turkish.team.CRS": "RİZ",
  "abbr.sb-turkish.team.ALS": "ALS",
  "sb-english.team.BRE": "Brentford",
  "abbr.sb-english.team.BRE": "BRE",
  "sb-english.team.NOT": "Nottingem F.",
  "abbr.sb-english.team.NOT": "NOT",
  "sb-spanish.team.ALV": "Alaves",
  "sb-spanish.team.ATB": "Atletik Bilbao",
  "sb-spanish.team.ATM": "Atletiko Madrid",
  "sb-spanish.team.FCB": "Barselona",
  "sb-spanish.team.CAD": "Cadiz",
  "sb-spanish.team.CLV": "Celta Viqo",
  "sb-spanish.team.ESP": "Espanyol",
  "sb-spanish.team.GET": "Getafe",
  "sb-spanish.team.GIR": "Girona",
  "sb-spanish.team.GRA": "Qranada",
  "sb-spanish.team.LAP": "Las Palmas",
  "sb-spanish.team.MAL": "Mayorka",
  "sb-spanish.team.OSA": "Osasuna",
  "sb-spanish.team.RAY": "Rayo Valyekano",
  "sb-spanish.team.BET": "Real Betis",
  "sb-spanish.team.MAD": "Real Madrid",
  "sb-spanish.team.SOC": "Real Scoiedad",
  "sb-spanish.team.SEV": "Sevilla",
  "sb-spanish.team.VAL": "Valensiya",
  "sb-spanish.team.VIL": "VİLLAREAL",
  "abbr.sb-spanish.team.ALV": "ALV",
  "abbr.sb-spanish.team.ATB": "ATB",
  "abbr.sb-spanish.team.ATM": "ATM",
  "abbr.sb-spanish.team.FCB": "FCB",
  "abbr.sb-spanish.team.CAD": "CAD",
  "abbr.sb-spanish.team.CLV": "CLV",
  "abbr.sb-spanish.team.ESP": "ESP",
  "abbr.sb-spanish.team.GET": "GET",
  "abbr.sb-spanish.team.GIR": "GIR",
  "abbr.sb-spanish.team.GRA": "GRA",
  "abbr.sb-spanish.team.LAP": "LAP",
  "abbr.sb-spanish.team.MAL": "MAL",
  "abbr.sb-spanish.team.OSA": "OSA",
  "abbr.sb-spanish.team.RAY": "RAY",
  "abbr.sb-spanish.team.BET": "BET",
  "abbr.sb-spanish.team.MAD": "MAD",
  "abbr.sb-spanish.team.SOC": "SOC",
  "abbr.sb-spanish.team.SEV": "SEV",
  "abbr.sb-spanish.team.VAL": "VAL",
  "abbr.sb-spanish.team.VIL": "VIL",
  "sb-scottish.team.ABE": "Aberdin",
  "sb-scottish.team.CEL": "kelt",
  "sb-scottish.team.DDU": "Dandi Yunayted",
  "sb-scottish.team.HEA": "Ürəklər",
  "sb-scottish.team.HIB": "hiberian",
  "sb-scottish.team.KIL": "Kilmarnock",
  "sb-scottish.team.LIV": "Livinqston",
  "sb-scottish.team.MOT": "Motherwell",
  "sb-scottish.team.RAN": "Rangers",
  "sb-scottish.team.STJ": "St Johnstone",
  "sb-scottish.team.STM": "Müqəddəs Mirren",
  "sb-scottish.team.DDE": "Dandi",
  "abbr.sb-scottish.team.ABE": "ABE",
  "abbr.sb-scottish.team.CEL": "CEL",
  "abbr.sb-scottish.team.DDU": "DDU",
  "abbr.sb-scottish.team.HEA": "HEA",
  "abbr.sb-scottish.team.HIB": "HIB",
  "abbr.sb-scottish.team.KIL": "KIL",
  "abbr.sb-scottish.team.LIV": "LIV",
  "abbr.sb-scottish.team.MOT": "MOT",
  "abbr.sb-scottish.team.RAN": "RAN",
  "abbr.sb-scottish.team.STJ": "STJ",
  "abbr.sb-scottish.team.STM": "STM",
  "abbr.sb-scottish.team.DDE": "DDE",
  "iihf-row.team.CAN": "Kanada",
  "iihf-row.team.FIN": "Finlandiya",
  "iihf-row.team.RUS": "Rusiya",
  "iihf-row.team.USA": "Amerika Birləşmiş Ştatları",
  "iihf-row.team.CZE": "Çexiya",
  "iihf-row.team.SWE": "İsveç",
  "iihf-row.team.SVK": "Slovakiya",
  "iihf-row.team.NOR": "Norveç",
  "iihf-row.team.DEN": "Danimarka",
  "abbr.iihf-row.team.CAN": "BACARMAQ",
  "abbr.iihf-row.team.FIN": "FIN",
  "abbr.iihf-row.team.RUS": "RUS",
  "abbr.iihf-row.team.USA": "ABŞ",
  "abbr.iihf-row.team.CZE": "ÇZE",
  "abbr.iihf-row.team.SWE": "İsveç",
  "abbr.iihf-row.team.SVK": "SVK",
  "abbr.iihf-row.team.NOR": "NOR",
  "abbr.iihf-row.team.DEN": "DEN",
  "event.Icematchresnt": "Matçın Nəticəsi (1X2) (Əsas vaxt)",
  "event.Icematchresot": "Matçın Nəticəsi (1,2) (Əlavə vaxt daxil olmaqla)",
  "event.Icebothteamstoscore": "Hər iki komanda qol vuracaq (Əsas vaxt)",
  "event.Icecorrectscoreot": "Düzgün hesab (əlavə vaxt daxil olmaqla)",
  "event.Iceexactgoalsot": "Dəqiq Məqsədlər (Əlavə vaxt daxil olmaqla)",
  "event.Icegamelines2nt": "Oyun Xətləri 2 tərəfli (Reqlama vaxtı)",
  "event.Icegamelines3nt": "Oyun Xətləri 3 tərəfli (Reqlama vaxtı)",
  "event.Iceou2p5totalgoalsot": "2,5-dən çox Ümumi Məqsəd (Əlavə vaxt daxil olmaqla)",
  "event.Iceou3p5totalgoalsot": "3,5-dən çox Ümumi Məqsəd (Əlavə vaxt daxil olmaqla)",
  "event.Iceou4p5totalgoalsot": "4,5-dən çox Ümumi Məqsəd (Əlavə vaxt daxil olmaqla)",
  "event.Iceteamaexactgoalsot": "Ev Komandasının Dəqiq Məqsədləri (Əlavə vaxt daxil olmaqla)",
  "event.Iceteambexactgoalsot": "Qonaq Komandanın Dəqiq Məqsədləri (Əlavə vaxt daxil olmaqla)",
  "event.Icematchresou3p5totalgoalsnt": "Matçın Nəticəsi və 3,5-dən yuxarı/az qol (Reqlament vaxtı)",
  "event.Icematchresou3p5totalgoalsot": "Matçın Nəticəsi və 3,5-dən yuxarı/az qol (əlavə vaxt daxil olmaqla)",
  "event.Icehighestscoreperiodnt": "Ən yüksək xal toplayan dövr xətləri (tənzimləmə vaxtı)",
  "event.Iceou25goalsteamateambot": "2,5-dən çox/az ev və ya səfər komandalarının qolları (əlavə vaxt daxil olmaqla)",
  "event.Icefirstteamtoscore": "Hansı Komanda ilk qol vuracaq? (Əlavə iş vaxtı daxil olmaqla)",
  "event.Iceteamtowinmostperiods": "Ən çox dövrə qalib gələn komanda (Reqlament vaxtı)",
  "selection.A": "{home}",
  "selection.B": "{away}",
  "selection.A -3.5": "{home} -3,5",
  "selection.A -3.0": "{home} -3,0",
  "selection.A -2.5": "{home} -2,5",
  "selection.A -2.0": "{home} -2,0",
  "selection.A -1.5": "{home} -1,5",
  "selection.A -1.0": "{home} -1,0",
  "selection.A +1.0": "{home} +1,0",
  "selection.A +1.5": "{home} +1,5",
  "selection.A +2.0": "{home} +2,0",
  "selection.A +2.5": "{home} +2,5",
  "selection.A +3.0": "{home} +3,0",
  "selection.A +3.5": "{home} +3,5",
  "selection.B -3.5": "{away} -3,5",
  "selection.B -3.0": "{away} -3,0",
  "selection.B -2.5": "{away} -2,5",
  "selection.B -2.0": "{away} -2,0",
  "selection.B -1.5": "{away} -1,5",
  "selection.B -1.0": "{away} -1,0",
  "selection.B +1.0": "{away} +1,0",
  "selection.B +1.5": "{away} +1,5",
  "selection.B +2.0": "{away} +2,0",
  "selection.B +2.5": "{away} +2,5",
  "selection.B +3.0": "{away} +3,0",
  "selection.B +3.5": "{away} +3,5",
  "selection.X -3.0": "X -3,0",
  "selection.X -2.0": "X -2,0",
  "selection.X -1.0": "X -1,0",
  "selection.X +1.0": "X +1,0",
  "selection.X +2.0": "X +2,0",
  "selection.X +3.0": "X +3,0",
  "selection.A & Over": "{home} & və Üzərində",
  "selection.A & Under": "{home} & və Aşağı",
  "selection.X & Over": "X & Üstü",
  "selection.X & Under": "X və altında",
  "selection.B & Over": "{away} & və artıq",
  "selection.B & Under": "{away} & və aşağı",
  "selection.A Over": "{home} Bitdi",
  "selection.A Under": "{home} altında",
  "selection.B Over": "{away} Bitdi",
  "selection.B Under": "{away} Altında"
}
